var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{attrs:{"limit":1,"on-remove":_vm.reomve,"file-list":_vm.fileList,"action":"","auto-upload":false,"on-change":_vm.change}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }